import {isNullOrUndefined} from "../../../services/Validator";

export default function PreviewScreenTitleText({title, extraClass}) {
    // Used in PreviewExerciserSideBar to display
    // top level information

    // BUILD
    if (isNullOrUndefined(title))
        return null
    return (
        <span className={"ml-[24px] text-[16px] " + extraClass}>
            {title}
        </span>
    )
}